var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "ol",
                {
                  staticClass: "body-1"
                },
                [
                  _c("li", [
                    _vm._v(
                      " Beginning January 1st, GreenGeeks/eNom will begin requiring complete WHOIS data for all gTLD domain name registrations. There are two methods are customers can use to send us this data – explicit information or default Billing Contact data. If you are sending us explicit contact information, you need to ensure the Registrant, Admin, and Tech fields are complete. If you rely on your default Billing data for new registrations, please ensure this data is complete. "
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      ' In addition to requiring "complete" WHOIS data, ICANN has mandated that the address, telephone, and email address be properly formatted. Therefore, beginning January 1st, all customers must ensure they are sending this data in the proper format. RFCs defining the formatting options are here: '
                    ),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          " Validate that all email addresses are in the proper format according to RFC 5322 (or its successors). "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " Validate that telephone numbers are in the proper format according to the ITU-T E.164 notation for international telephone numbers (or its equivalents or successors). "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " Validate that postal addresses are in a proper format for the applicable country or territory as defined in Universal Postal Union (UPU) addressing format templates, the S42 address templates (as they may be updated) or other standard formats. "
                        )
                      ])
                    ])
                  ]),
                  _c("li", [
                    _vm._v(
                      " ICANN has requested that Registrars verify the Registrant email address associated with gTLD new domain name registrations. GreenGeeks/eNom recognizes that this is a change from how our clients manage their new registrations today. Thus, we have outlined our process below for addressing this verification mandate: "
                    ),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          " Beginning January 1st, all gTLD new registrations processed through GreenGeeks/eNom will be subject to email verification. Specifically, we will be focused on verifying the Registrant email address. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " When a new domain registration is received, GreenGeeks/eNom will send an email to the Registrant email address. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " The email will inform you that you must verify your email address within 15 calendar days of the domain name registration. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " If you click the link within this email, GreenGeeks/eNom will consider the Registrant as verified (future registrations from this Registrant will not require further verification) "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " If the Registrant does not verify themselves within the 15 calendar day window, ICANN/eNom will overtake the DNS of the domain name and post a page on the site listing instructions on how the name can be verified and, as a result, the DNS returned to the previous settings. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " Once a Registrant contact has completed the verification process, all future new registrations using that same Registrant contact information will be considered verified and will not be subject to the verification process. "
                        )
                      ])
                    ])
                  ]),
                  _c("li", [
                    _vm._v(
                      " ICANN has mandated that Registrars also utilize the above verification process when a domain name Registrant edits their First Name, Last Name, or email address information. As a result, GreenGeeks/eNom will manage this modification process as follows: "
                    ),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          " Beginning January 1st, GreenGeeks/eNom will utilize the verification procedure if an edit is made to the following Registrant fields: "
                        ),
                        _c("ol", [
                          _c("li", [_vm._v("Registrant First Name")]),
                          _c("li", [_vm._v("Registrant Last name")]),
                          _c("li", [_vm._v("Registrant Email Address")])
                        ])
                      ]),
                      _c("li", [
                        _vm._v(
                          " GreenGeeks/eNom will send a white labeled email to the Registrant new email address stating that we recognize they have modified their Registrant First Name, Last Name, or email address information and we are requesting they verify themselves by clicking on the link in the email. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          ' If you click on the link in the email within 15 calendar days, we will accept the Contact as verified. The Registrant is then considered "verified" and will require no further verification. '
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " If you do not click on the link within 15 calendar days, then ICANN/eNom will overtake the DNS of the domain name associated with that specific Registrant contact. NOTE: In some cases, Resellers utilize the Account Information on file to populate the Registrant field. If the Account Information is modified and not verified within the 15 day verification window, then all domain names associated with this Contact will be be suspended. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " Once a Registrant contact has completed the verification process, all future domain names that are updated to this same contact information will not be subject to the verification process. "
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }